import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { DeviceInfo } from 'src/app/models/device-models/device-info-model/device-info.model';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-broadcastings-new-broadcasting-creation-card',
  templateUrl: './broadcastings-new-broadcasting-creation-card.component.html',
  styleUrls: ['./broadcastings-new-broadcasting-creation-card.component.scss']
})
export class BroadcastingsNewBroadcastingCreationCardComponent implements OnInit, OnDestroy {

  centerList;
  devices;
  selectedCenters;
  selectedDevices;
  showButton;
  basicDataForm = new FormGroup({
    active: new FormControl(false),
    name: new FormControl(null, Validators.required)
  });
  getBroadcastingDevicesSubscription: Subscription;
  addNewBroadcastingSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
              private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private spinnerService: SpinnerService) {
                this.showButton = true;
                this.selectedDevices = new Array<DeviceInfo>();
              }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.getBroadcastingDevices(this.centerList);
  }

  public addNewBroadcasting() {
    this.showButton = false;
    this.spinnerService.show('broadcasting-new-spinner');
    const centersInternalIdList = new Array<string>();
    const validation = this.validateForm();
    if (validation === true) {
      if (this.selectedCenters) {
        this.selectedCenters.forEach(
          (c) => {
            centersInternalIdList.push(c.InternalId);
          }
        );
      }
      this.addNewBroadcastingSubscription = this.broadcastingsService.addNewBroadcasting(this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.selectedCenters, this.selectedDevices).pipe(
        tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.add broadcasting success', 'success')),
        tap(o => this.spinnerService.hide('broadcasting-new-spinner')),
        tap(o => this.router.navigate(['/broadcastings'], { relativeTo: this.activatedRoute })),
        catchError(error => {
          this.showButton = true;
          this.spinnerService.hide('broadcasting-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
          return EMPTY;
        })
      ).subscribe();
    } else {
      this.showButton = true;
      this.spinnerService.hide('broadcasting-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name broadcasting error';
    } else {
      return true;
    }
  }

  public centersDuallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
      this.getBroadcastingDevices(this.selectedCenters);
    }
  }

  public devicesDuallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDevices = aux;
    }
  }

  public getBroadcastingDevices(centers) {
    const internalIdList = new Array<string>();
    centers.forEach(
      (c) => {
        internalIdList.push(c.InternalId);
      }
    );
    this.getBroadcastingDevicesSubscription = this.broadcastingsService.getBroadcastingDevices(internalIdList).pipe(
      tap(o => this.devices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public cancelBroadcasting() {
    this.router.navigate(['/broadcastings'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    if (this.getBroadcastingDevicesSubscription) { this.getBroadcastingDevicesSubscription.unsubscribe(); }
  }
}
